﻿import { Enumerable, KboOutputField } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { Constraint } from "@models/configurators/output-fields/cad/mates/constraint";
import { OutputField } from "@models/configurators/output-fields/output-field";
import { ICadDynamicComponentField } from "@models/entity-models";
import { eOutputFieldType } from "@models/enums";

@KboOutputField(CToken.CadDynamicComponentField, eOutputFieldType.cadDynamicComponent)
export class CadDynamicComponentField extends OutputField implements ICadDynamicComponentField {
    constructor(kom: KbObjectManager) {
        super(kom);
    }

    public filePath: string;
    public absoluteCompName: string;
    public partFamilyName: string;
    public suppressed: boolean;
    public fixed: boolean;
    public newName: string;
    public source: string;
    public sourceId: string;
    public nestedName: string;
    public nestedIdProduct: number;

    private _constraints: Constraint[];
    @Enumerable()
    public get constraints(): OutputField[] {
        if (!this._constraints) this._constraints = [];
        return this._constraints;
    }
    public set constraints(val) {
        this._constraints = val;
    }

    public addConstraint = (constraintType: eOutputFieldType, args?: any): Constraint => {
        let constraint = OutputField.getNewOutputFieldOfType(constraintType, this.$manager, args);
        constraint.type = constraintType;
        this.$manager.addKbObject(constraint, this);
        this.constraints.push(constraint);
        return constraint;
    }

    public removeConstraint = constraint => {
        this.$manager.removeKbObject(constraint);
        this.constraints.remove(constraint);
    }
}
